<div class="panel rs-bg-grey1 clearfix">
  <div class="rs-flex-row">
    <div class="rs-flex-column">
      <h3 class="rs-tit6 rs-txt-c1 rs-padding-bottom2">
        {{ 'mobile.pricingPlan.esim.title' | translate }}
      </h3>
    </div>
  </div>

  <div
    class="rs-msgbox"
    [ngClass]="{ 'rs-margin-bottom2': isMobile }"
    data-alert=""
    aria-live="assertive"
    role="alertdialog"
  >
    <div class="rs-msgbox-title">
      {{ 'mobile.pricingPlan.esim.install.title.label' | translate }}
    </div>
    <div class="rs-msgbox-content">
      <p id="eSimMobileViewInfo" *ngIf="isMobile">
        {{ 'mobile.pricingPlan.esim.mobileview.info.label' | translate }}
      </p>
      <p *ngIf="!isMobile">{{ 'mobile.pricingPlan.esim.install.description.label' | translate }}</p>
    </div>
    <div class="rs-msgbox-icon">
      <i class="icon-Information-box" aria-hidden="true"></i>
    </div>
  </div>

  <ng-container *ngIf="!isMobile">
    <div *ngIf="!qrCodeValue">
      <button
        (click)="showQrCodeSection()"
        id="eSimCodesButton"
        class="rs-btn rs-btn-next rs-maxw jsrs-show-sim-details"
        data-tms-event="button-click"
        data-tms-button-zone="mobile options"
        data-tms-button-name="See eSIM QR code and PUK"
      >
        {{ 'mobile.pricingPlan.esim.qrcode.button' | translate }}
        <i class="icon-Arrowbutton rs-margin-left1" aria-hidden="true"></i>
      </button>
    </div>

    <div *ngIf="qrCodeValue" class="rs-flex-row">
      <div class="rs-flex-column rs-flex-shrink">
        <div class="rs-margin-right3">
          <qrcode [qrdata]="qrCodeValue" [width]="100" [errorCorrectionLevel]="'M'"></qrcode>
        </div>
      </div>
      <div class="rs-flex-column">
        <p class="rs-font-pxB">
          <span class="rs-txt-purple">{{
            'mobile.pricingPlan.esim.pukcode.label' | translate
          }}</span
          ><br />{{ eSimData.puk1 }}
        </p>
        <p class="rs-font-pxB">
          <span class="rs-txt-purple">{{
            'mobile.pricingPlan.esim.esimcode.label' | translate
          }}</span
          ><br />{{ eSimData.simCardNumber }}
        </p>
      </div>
    </div>
  </ng-container>
  <div *ngIf="('sim.enable' | translate) !== 'false'" class="text-right">
    <a
      class="rs-btn rs-btn-third"
      [routerLink]="['/details/mobile', eSimData.msisdn, 'esim']"
    >
      {{ "sim.manage-sim-card" | translate }}
      <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i>
    </a>
  </div>
</div>
